import React, {Component} from 'react';
import moment from 'moment';
import DateTimePicker from '../common/DateTimePicker';
import {DATE_TIME_FORMAT} from '../../components/helpers/DateHelper';
import { injectIntl } from 'react-intl';
import {messages} from  '../common/Translations';


const PublishAt = ({intl, input}) => {
    return (
        <div data-cy-publish-at className="form-group row">
            <label className="col-sm-2 col-form-label">
                <b>{intl.formatMessage(messages.publishedAt)}</b>
            </label>
            <div className="col-sm-10 p-0">
                <DateTimePicker
                    value={input.value ? moment(input.value, DATE_TIME_FORMAT) : moment()}
                    formInput={input}
                />
                <small className="text-muted p-l-10">(dd-mm-åååå tt:mm)</small>
            </div>
        </div>
    )
};

export default injectIntl(PublishAt);


// WEBPACK FOOTER //
// ./web/src/components/articles/PublishAt.jsx